import React from 'react';

interface LogoProps {
  className?: string;
  /** 'white' renders the transparent logo in white (for dark surfaces); 'natural' keeps its own colours. */
  variant?: 'white' | 'natural';
}

/** DKSN transparent brand logo. */
const Logo = ({ className = '', variant = 'white' }: LogoProps) => (
  <img
    src="/images/logo-small.webp"
    alt="DKSN Business Solutions"
    width={260}
    height={107}
    className={`h-9 w-auto ${className}`}
    style={variant === 'white' ? { filter: 'brightness(0) invert(1)' } : undefined}
  />
);

export default Logo;
